<template>
	<page>
		<div class="state flex-column flex-center">
			<i class="state-icon tf">&#xe638;</i>
			<p>操作成功</p>
		</div>

		<div class="button flex-center">
			<c-button size="form" color="main" @click="mp.redirectWeb(path)">继续操作</c-button>
			<c-button size="form" color="main" hollow @click="mp.navigateBack()">返回工作台</c-button>
		</div>
	</page>
</template>

<script>
	export default {
		props: {
			scene: String
		},

		computed: {
			path() {
				return {
					in: '/stock/in',
					out: '/stock/out',
					allot: '/stock/allot'
				}[this.scene]
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.state {
		gap: .24rem;
		padding-top: .96rem;
		font-size: .4rem;
		color: #0EB775;

		&-icon {
			font-size: 1.2rem;
		}
	}

	.button {
		gap: .28rem;
		margin-top: .54rem;

		>>> .c-button {
			width: 2.8rem;
		}
	}
</style>